var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import 'whatwg-fetch';
import { getCookie, setAuthCookies, hasLoginCookie, isTokenExpired, setNotLoggedAuthCookies, } from './cookies';
import { getUrlTo, unsupportedBrowsers } from '../utils';
import { getServerHost, isRequiredAuthOnSign, isSignApp, getSigningProcessIdFromUrl, } from './hosts';
const isLogoutEndpoint = (path) => path === 'logout';
export const HEADERS = {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
};
const fetchNotLoggedSignCookies = () => __awaiter(void 0, void 0, void 0, function* () {
    const id = getSigningProcessIdFromUrl();
    return window.fetch(`${getServerHost()}/documentlinks/${id}/refresh-token`, {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        method: 'PUT',
    });
});
const getNewTokens = () => __awaiter(void 0, void 0, void 0, function* () {
    return window.fetch(`${getServerHost()}/refresh`, {
        headers: { 'Content-Type': 'application/json' },
        method: 'PUT',
    });
});
export const refreshNotLoggedSignCookies = () => __awaiter(void 0, void 0, void 0, function* () {
    const isUnsupportedBrowser = unsupportedBrowsers(window.navigator);
    if (isSignApp() && !isRequiredAuthOnSign() && !isUnsupportedBrowser) {
        const refreshTokenResponse = yield fetchNotLoggedSignCookies();
        if (refreshTokenResponse.status === 401) {
            window.location.href = `${getUrlTo('sign')}/session-expired`;
            return;
        }
        if (refreshTokenResponse.status >= 200 &&
            refreshTokenResponse.status < 300) {
            setNotLoggedAuthCookies();
        }
    }
});
export const refreshLoggedSelfServiceCookies = (defaultOpts, path) => __awaiter(void 0, void 0, void 0, function* () {
    if (hasLoginCookie() &&
        isTokenExpired() &&
        !isLogoutEndpoint(path) &&
        !window.location.pathname.includes('logout')) {
        window.location.href = `${getUrlTo('accounts')}/logout?redirectUrl=${encodeURIComponent(window.location.href)}&autoLogout`;
        return;
    }
    if (hasLoginCookie() && isTokenExpired(900000) && !isLogoutEndpoint(path)) {
        const refreshTokenResponse = yield getNewTokens();
        if (refreshTokenResponse.status >= 200 &&
            refreshTokenResponse.status < 300) {
            const json = yield refreshTokenResponse.json();
            setAuthCookies(json, getCookie('email'));
            window.dispatchEvent(new Event('tokenRefreshed'));
        }
    }
});
const getDefaultApiOpts = () => ({
    headers: {},
    logoutWhenUnauthorized: true,
    onLogoutUrl: getUrlTo('accounts'),
    refreshSignToken: true,
});
export const apiCall = ({ method, path, body, options, }) => __awaiter(void 0, void 0, void 0, function* () {
    const defaultOpts = Object.assign(Object.assign({}, getDefaultApiOpts()), options);
    const fullUrl = `${getServerHost()}/${path}`;
    const headers = Object.assign(Object.assign({}, HEADERS), defaultOpts.headers);
    if (defaultOpts.refreshSignToken) {
        yield refreshNotLoggedSignCookies();
    }
    yield refreshLoggedSelfServiceCookies(defaultOpts, path);
    const response = yield fetch(fullUrl, {
        method,
        body: body && JSON.stringify(body),
        credentials: 'include',
        headers,
    });
    if (!response.ok) {
        yield failedResponseSideEffects(response, defaultOpts);
        return Promise.reject(response);
    }
    return response;
});
const failedResponseSideEffects = (response, defaultOpts) => __awaiter(void 0, void 0, void 0, function* () {
    if (!defaultOpts.logoutWhenUnauthorized) {
        return;
    }
    if (response.status === 401 && !isSignApp()) {
        window.location.href = `${getUrlTo('accounts')}/logout?redirectUrl=${defaultOpts.onLogoutUrl}&autoLogout`;
        return;
    }
    if (response.json) {
        const clone = response.clone();
        const json = yield clone.json();
        if (json.exceptionId === 'account.not.found') {
            window.location.href = `${getUrlTo('accounts')}/logout?redirectUrl=${defaultOpts.onLogoutUrl}`;
        }
    }
    return;
});
export const getApiPartial = () => ({
    get: (path, body, options) => apiCall({
        method: 'GET',
        path,
        body,
        options,
    }),
    post: (path, body, options) => apiCall({
        method: 'POST',
        path,
        body,
        options,
    }),
    patch: (path, body, options) => apiCall({
        method: 'PATCH',
        path,
        body,
        options,
    }),
    put: (path, body, options) => apiCall({
        method: 'PUT',
        path,
        body,
        options,
    }),
    delete: (path, body, options) => apiCall({
        method: 'DELETE',
        path,
        body,
        options,
    }),
});
export const api = Object.assign({}, getApiPartial());
